<template>
    <div class="chart">
      <v-chart force-fit="true" :width="width" :height="height" :padding="padding" :data="data" :scale="scale">
        <!--<v-tooltip />-->
        <v-axis :dataKey="axis1Opts.dataKey" :line="axis1Opts.line" :tickLine="axis1Opts.tickLine" :grid="axis1Opts.grid" />
        <v-axis :dataKey="axis2Opts.dataKey" :label="null" :line="axis2Opts.line" :tickLine="axis2Opts.tickLine" :grid="axis2Opts.grid" />
        <v-legend dataKey="key" marker="circle" :offsetY="-10" />
        <v-coord type="polar" :radius="0.7" />
        <v-line position="item*score" :color="['key', ['rgba(0,200,130,1)','rgba(63,142,255,1)']]" :size="1" />
        <v-area position="item*score" :color="['key', ['rgba(0,200,130,0.2)','rgba(63,142,255,0.2)']]" />
        <v-point
          position="item*score"
          :color="['key', ['#00C882','#3F8EFF']]"
          :size="4"
          shape="circle"
          :style="{ stroke: '#fff', lineWidth: 1, fillOpacity: 1,}"
        />

    </v-chart>
  </div>
</template>

<style lang="stylus" scoped>

</style>
<script>
import { DataView } from '@antv/data-set'
import { cloneDeep } from 'lodash'
export default {

  data() {
    return {
      data: [],
      scale: [{ dataKey: 'score', min: 0, max: 10 }, { dataKey: 'key', formatter: val => ({ class: '班级平均表现', personal: '个人综合表现' }[val]) }],
      axis1Opts: {
        dataKey: 'item',
        line: null,
        tickLine: null,
        grid: {
          lineStyle: {
            lineDash: null
          },
          hideFirstLine: false
        }
      },
      axis2Opts: {
        dataKey: 'score',
        line: null,
        tickLine: null,
        grid: {
          type: 'circle',
          lineStyle: {
            lineDash: [2, 2, 2]
          }
        }
      }
    }
  },
  props: {
    height: {
      type: Number,
      default: 300
    },
    width: {
      type: Number,
      default: 300
    },
    padding: {
      type: Array,
      default: () => ([20, 20, 20, 20])
    },
    sourceData: {
      type: Array,
      default: () => ([])
    }
  },
  watch: {
    sourceData: {
      handler: function (val, oldVal) {
        if (val.length) {
          this.initChart()
        }
      },
      immediate: true
    }
  },
  methods: {
    initChart () {
      // 防止不停更新this.sourceData导致init不停触发
      const sourceData = cloneDeep(this.sourceData)

      if (!sourceData.length) { return }
      const dv = new DataView()
      dv.source(sourceData).transform({
        type: 'fold',
        fields: ['personal', 'class'], // 展开字段集
        key: 'key', // key字段
        value: 'score' // value字段
      })
      this.$data.data = dv.rows
    }
  },
  mounted() {
  }
}
</script>
